import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { buttonVariants } from "../../button/styles/index.js";
const paginationButtonVariants = tv({
  extend: buttonVariants,
  variants: {
    isCtrlBtn: {
      true: "gap-1 px-2.5 sm:pr-2.5",
      false: void 0
    }
  },
  compoundVariants: [
    { size: "default", shape: "square", class: "min-w-9 h-9 px-3" },
    { size: "sm", shape: "square", class: "min-w-8 h-8 px-2" },
    { size: "lg", shape: "square", class: "min-w-10 h-10 px-5" },
    { size: "xs", shape: "square", class: "min-w-6 h-6 px-1" }
  ]
});
export {
  paginationButtonVariants
};
//# sourceMappingURL=index.js.map
